import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {SimplePresentationRunner} from "../winpresentation/SimplePresentationRunner";
import {DropInPresentation} from "../runnerpresentations/DropInPresentation";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class KitchenDramaSushiManiaNormalResultPresentation implements FlowStatePresentation {


    constructor() {}

    public start(flowStateController:FlowStateController) {
        //flowStateController.finish();
        const presentations = [];
        presentations.push(new DropInPresentation());
        SimplePresentationRunner.run(presentations, () => flowStateController.finish(), (callback?:Function) => flowStateController.setSkipCallback(callback), "ResultRunner");
    }



}